import { enUS, hu, sk, type Locale } from 'date-fns/locale';

const dateFnsLocales: Record<string, Locale> = {
  hu,
  en: enUS,
  sk,
};

export function getDateFnsLocale(lang: string): Locale {
  const normalized = lang.split('-')[0];

  return dateFnsLocales[lang] ?? dateFnsLocales[normalized] ?? hu;
}
